import { DEFAULT_PAGE_GUIDE_SETTINGS } from '@/components/canvas/page/guideSettings';
import type { Page, PageWorkspaceLayout } from '@/components/canvas/document/publicTypes';

export type CreatePageOptions = {
  workspaceLayout?: PageWorkspaceLayout;
  name?: string;
};

/** 按指定尺寸创建空白 Page */
export function createPageWithSize(
  width: number,
  height: number,
  options?: CreatePageOptions,
): Page {
  return {
    id: `page-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    name: options?.name ?? '',
    size: { width, height },
    background: { type: 'color', value: '#ffffff' },
    elements: [],
    blocks: [],
    guideSettings: { ...DEFAULT_PAGE_GUIDE_SETTINGS, grid: { ...DEFAULT_PAGE_GUIDE_SETTINGS.grid } },
    workspaceLayout: options?.workspaceLayout ?? { x: 0, y: 0, zIndex: 0 },
    createdAt: Date.now(),
    updatedAt: Date.now(),
  };
}
